// src/resizeObserverPatch.ts
// Side-effect-only module: patches ResizeObserver before anything else mounts.
if (typeof window !== "undefined" && "ResizeObserver" in window) {
  const OriginalResizeObserver = window.ResizeObserver;

  window.ResizeObserver = class PatchedResizeObserver extends OriginalResizeObserver {
    constructor(callback: ResizeObserverCallback) {
      super((entries, observer) => {
        window.requestAnimationFrame(() => {
          callback(entries, observer);
        });
      });
    }
  };
}

export {};